import {PageDefinition, PageManager} from "@pledger/frontend-commons";
import {PageId, pageIdOf} from "../../ui/app/Pages/PageId";
import {pageDefinitions} from "../../ui/app/Pages/PageDefinitions";
import {Reducer} from "redux";
import {PledgerPageComponentState} from "./PledgerPageComponentState";


export class AppPageManager extends PageManager<PageId,PledgerPageComponentState> {
    getPageDefinition(pageId: string): PageDefinition<PageId,PledgerPageComponentState> {
        return this.getPageDefinitionFromId(this.pageIdOf(pageId))!;
    }

    pageIdOf(pageId: string): PageId {
        return pageIdOf(pageId);
    }

    stringIdOf(pageId: PageId): string {
        return pageId;
    }

}
export const pageManager = new AppPageManager(pageDefinitions);

export const pageId : Reducer<PageId> = pageManager.buildPageIdReducer(PageId.NONE, PageId.HOME_PAGE_ID);
